import FrameImageRepository from "./Repositories/FrameImageRepository";
import FrameImagePreloader from "./FrameImagePreloader.js";
import DetailEventHandler from "./EventHandlers/DetailEventHandler";
import ListEventHandler from "./EventHandlers/ListEventHandler";
import GeneralEventHandler from "./EventHandlers/GeneralEventHandler";
import SearchEventHandler from "./EventHandlers/SearchEventHandler";
import CheckoutEventHandler from "./EventHandlers/CheckoutEventHandler";
import ProductSearchRepository from "./Repositories/ProductSearchRepository";

export default class Factory
{
    /**
     * @returns {FrameImageRepository}
     */
    static getFrameImageRepository() {
        let self = this;
        return new FrameImageRepository(
            self.getFrameImagePreloader(),
        );
    }
    /**
     * @returns {FrameImagePreloader}
     */
    static getFrameImagePreloader() {
        return new FrameImagePreloader();
    }
    /**
     * @returns {GeneralEventHandler}
     */
    static getGeneralEventHandler() {
        return new GeneralEventHandler();
    }
    /**
     * @returns {CheckoutEventHandler}
     */
    static getCheckoutEventHandler() {
        return new CheckoutEventHandler();
    }
    /**
     * @returns {SearchEventHandler}
     */
    static getSearchEventHandler() {
        return new SearchEventHandler(() => this.getProductSearchRepository());
    }
    /**
     * @returns {ProductSearchRepository}
     */
    static getProductSearchRepository() {
        return new ProductSearchRepository();
    }
    /**
     * @returns {DetailEventHandler}
     */
    static getDetailEventHandler() {
        return new DetailEventHandler(jQuery(document).find('.single-product'));
    }
    /**
     * @returns {ListEventHandler}
     */
    static getListEventHandler() {
        return new ListEventHandler();
    }
}
